import { Injectable } from '@angular/core';
import { PostmethodService } from '../../app-config/postmethod.service';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MsPinService {
  constructor(private ws: PostmethodService) { }

  mspinCrud(request: any) {
    return this.ws.wsPost(request, environment.masterUrl + "mspinMaster");
  }

  roleCrud(request: any) {
    return this.ws.wsPost(request, environment.masterUrl + "roleMaster");
  }

  getAllOutlet() {
    return this.ws.wsGet(environment.baseUrl + "masters/outlet");
  }

}
